import { render, staticRenderFns } from "./VaButtonGroup.demo.vue?vue&type=template&id=4e8e2e0c&"
import script from "./VaButtonGroup.demo.vue?vue&type=script&lang=js&"
export * from "./VaButtonGroup.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports